// @flow
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { Dispatch } from 'redux';
import Error204 from '.';
import { filtersCountSelector } from '../../../Serp/selectors';
import { trackEvent } from '../../../tracking/actions';
import {
  showSearchFilters,
  hideSearchFilters,
} from '../../../Serp/components/Filters/shared/actions';

type MapStateToProps = {
  filtersCount: number,
};

type MapDispatchToProps = {
  trackEvent: Function,
  showSearchFilters: Function,
  hideSearchFilters: Function,
};

export const mapStateToProps = (state: Object): MapStateToProps => ({
  filtersCount: filtersCountSelector(state),
});

export const mapDispatchToProps = (dispatch: Dispatch<*>) =>
  ({
    trackEvent: event => dispatch(trackEvent(event)),
    showSearchFilters: () => dispatch(showSearchFilters()),
    hideSearchFilters: () => dispatch(hideSearchFilters()),
  }: MapDispatchToProps);

const Error204Container = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Error204);

Error204Container.displayName = 'Error204Container';

export default Error204Container;



// WEBPACK FOOTER //
// ./app/Error/components/Error204/container.js